export default __webpack_public_path__ + "static/media/camera.b06c0d50.svg";